import { render, staticRenderFns } from "./ProyeccionHidrocarburosIndex.vue?vue&type=template&id=09e65e9a"
import script from "./ProyeccionHidrocarburosIndex.vue?vue&type=script&lang=js"
export * from "./ProyeccionHidrocarburosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports